import { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box, Card, Button, CircularProgress, Select, MenuItem, FormControl, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiget, apiput } from '../service/api';
import AppWidgetSummary from '../sections/@dashboard/app/AppWidgetSummary';

export default function DashboardAppPage() {
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalTodayLeads, setTotalTodayLeads] = useState(0);
  const [totalYesterdayLeads, setTotalYesterdayLeads] = useState(0);
  const [totalWeekLeads, setTotalWeekLeads] = useState(0);
  const [totalMonthLeads, setTotalMonthLeads] = useState(0);
  const [totalPreApprovedLeads, setTotalPreApprovedLeads] = useState(0);
  const [totalRefiAcceptedLeads, setTotalRefiAcceptedLeads] = useState(0);
  const [leadData, setLeadData] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('all');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [newAssignedAgent, setNewAssignedAgent] = useState('');

  const userid = localStorage.getItem('user_id');
  const userRole = localStorage.getItem('userRole');
console.log("user role", userRole);

 const fetchLeadsByDate = async (startDate, endDate) => {
  if (!userRole) return 0; // ⛔ Skip if no role
  const start = new Date(startDate);
  const end = new Date(endDate);

  const result = await apiget(
    userRole === 'admin'
      ? `lead/list/?createdOn[$gte]=${start.toISOString()}&createdOn[$lte]=${end.toISOString()}`
      : `lead/list/?createdBy=${userid}&createdOn[$gte]=${start.toISOString()}&createdOn[$lte]=${end.toISOString()}`
  );
  return result && result.status === 200 ? result.data.total_recodes : 0;
};

const fetchLeadsByField = async (fieldName, value) => {
  if (!userRole) return 0; // ⛔ Skip if no role
  const result = await apiget(
    userRole === 'admin'
      ? `lead/list/?${fieldName}=${value}`
      : `lead/list/?${fieldName}=${value}&createdBy=${userid}`
  );
  return result && result.status === 200 ? result.data.total_recodes : 0;
};

const fetchTotalLeads = async () => {
  if (!userRole) return 0; // ⛔ Skip if no role
  const result = await apiget(
    userRole === 'admin'
      ? 'lead/list'
      : `lead/list/?createdBy=${userid}`
  );
  return result && result.status === 200 ? result.data.total_recodes : 0;
};

  const fetchUsers = async () => {
  if (!userRole) return; // ⛔ Skip if no role
  const result = await apiget('user/list');
  if (result && result.status === 200) {
    setUsers(result.data.result);
  }
};

  const navigate = useNavigate();

  const handleOpenEdit = (leadId) => {
    navigate(`/dashboard/lead/edit/${leadId}`);
  };

  const fetchLeadData = async (filterType) => {
  if (!userRole) return; // ⛔ Skip if no role
  setLoading(true);
  try {
    let result;
    if (filterType === 'today') {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      result = await apiget(
        userRole === 'admin'
          ? `lead/list/?createdOn[$gte]=${today.toISOString()}`
          : `lead/list/?createdBy=${userid}&createdOn[$gte]=${today.toISOString()}`
      );
    } else if (filterType === 'yesterday') {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      result = await apiget(
        userRole === 'admin'
          ? `lead/list/?createdOn[$gte]=${yesterday.toISOString()}&createdOn[$lt]=${today.toISOString()}`
          : `lead/list/?createdBy=${userid}&createdOn[$gte]=${yesterday.toISOString()}&createdOn[$lt]=${today.toISOString()}`
      );
    } else if (filterType === 'week') {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay());
      result = await apiget(
        userRole === 'admin'
          ? `lead/list/?createdOn[$gte]=${startOfWeek.toISOString()}`
          : `lead/list/?createdBy=${userid}&createdOn[$gte]=${startOfWeek.toISOString()}`
      );
    } else if (filterType === 'month') {
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      result = await apiget(
        userRole === 'admin'
          ? `lead/list/?createdOn[$gte]=${startOfMonth.toISOString()}`
          : `lead/list/?createdBy=${userid}&createdOn[$gte]=${startOfMonth.toISOString()}`
      );
    } else if (filterType === 'pre-approved') {
      result = await apiget(
        userRole === 'admin'
          ? `lead/list/?preApproved=Yes`
          : `lead/list/?preApproved=Yes&createdBy=${userid}`
      );
    } else if (filterType === 'refi-accepted') {
      result = await apiget(
        userRole === 'admin'
          ? `lead/list/?refiOfferAccepted=Yes`
          : `lead/list/?refiOfferAccepted=Yes&createdBy=${userid}`
      );
    } else {
      result = await apiget(
        userRole === 'admin'
          ? 'lead/list'
          : `lead/list/?assigned_agent=${userid}`
      );
    }

    setLeadData(result?.data?.result || []);
  } catch (error) {
    console.error('Error fetching lead data:', error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    const fetchData = async () => {
      setTotalLeads(await fetchTotalLeads());
      await fetchUsers();
      setTotalTodayLeads(await fetchLeadsByDate(new Date().setHours(0, 0, 0, 0), new Date()));
      const yesterday = new Date(new Date().setHours(0, 0, 0, 0));
      yesterday.setDate(yesterday.getDate() - 1);
      setTotalYesterdayLeads(await fetchLeadsByDate(yesterday, new Date(new Date().setHours(0, 0, 0, 0))));
      const startOfWeek = new Date(new Date().setHours(0, 0, 0, 0));
      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
      setTotalWeekLeads(await fetchLeadsByDate(startOfWeek, new Date()));
      const startOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setTotalMonthLeads(await fetchLeadsByDate(startOfMonth, new Date()));
      setTotalPreApprovedLeads(await fetchLeadsByField('preApproved', 'Yes'));
      setTotalRefiAcceptedLeads(await fetchLeadsByField('refiOfferAccepted', 'Yes'));
    };
    fetchData();
  }, []);

  useEffect(() => {
    fetchLeadData(filter);
  }, [filter]);

  const handleAgentChange = (lead, agentId) => {
    setSelectedLead(lead);
    setNewAssignedAgent(agentId);
    setOpenDialog(true);
  };

  const handleConfirmChange = async () => {
    try {
      const result = await apiput(`lead/edit/${selectedLead._id}`, { assigned_agent: newAssignedAgent });
      if (result.status === 200) {
        toast.success('Lead assigned agent updated successfully!');
        fetchLeadData(filter);
      } else {
        toast.error('Failed to update assigned agent.');
      }
    } catch (error) {
      toast.error('Error updating assigned agent.');
    } finally {
      setOpenDialog(false);
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const columns = [
    {
      field: 'firstName',
      headerName: 'First Name',
      flex: 1,
      renderCell: (params) => {
        const handleFirstNameClick = () => {
          navigate(`/dashboard/lead/view/${params.row._id}`);
        };
        return <Box onClick={handleFirstNameClick}>{params.value}</Box>;
      }
    },
    { field: 'lastName', headerName: 'Last Name', flex: 1 },
    { field: 'createdOn', headerName: 'Created Date', flex: 1, valueGetter: (params) => new Date(params.row.createdOn).toLocaleDateString() },
    {
      field: 'leadStatus',
      headerName: 'Lead Status',
      flex: 1,
      valueGetter: (params) => params.row.leadStatus || 'N/A'
    },
    {
      field: 'assigned_agent',
      headerName: 'Assigned Agent',
      flex: 1,
      renderCell: (params) => {
        return (
          <FormControl fullWidth>
            <Select
              value={params.row.assigned_agent || ''}
              onChange={(e) => handleAgentChange(params.row, e.target.value)}
            >
              {users.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {`${user.firstName} ${user.lastName}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      }
    },
    { field: 'leadSource', headerName: 'Lead Intake From', flex: 1 },
    
  ];

  const getBoxStyle = (boxType) => ({
    cursor: 'pointer',
    borderColor: filter === boxType ? 'primary.main' : 'transparent',
    borderWidth: filter === boxType ? 2 : 1,
    borderStyle: 'solid'
  });

  return (
    <Container sx={{ position: 'relative' }}>
      <Typography variant="h4" sx={{ mb: 5 }}>Hi, Welcome back</Typography>

      {/* Key Metrics */}
      <Grid container spacing={3} sx={{ mb: 5 }}>
        <Grid item xs={12} sm={3}>
          <AppWidgetSummary title="Total Leads" total={totalLeads} icon={'ic:baseline-supervisor-account'} onClick={() => setFilter('all')} sx={getBoxStyle('all')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <AppWidgetSummary title="Leads Today" total={totalTodayLeads} icon={'ic:baseline-today'} onClick={() => setFilter('today')} sx={getBoxStyle('today')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <AppWidgetSummary title="Leads Yesterday" total={totalYesterdayLeads} color="info" icon={'ic:baseline-yesterday'} onClick={() => setFilter('yesterday')} sx={getBoxStyle('yesterday')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <AppWidgetSummary title="Leads This Week" total={totalWeekLeads} color="warning" icon={'ic:baseline-week'} onClick={() => setFilter('week')} sx={getBoxStyle('week')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <AppWidgetSummary title="Leads This Month" total={totalMonthLeads} color="success" icon={'ic:baseline-calendar-today'} onClick={() => setFilter('month')} sx={getBoxStyle('month')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <AppWidgetSummary title="Pre-Approved Leads" total={totalPreApprovedLeads} color="primary" icon={'ic:baseline-check-circle'} onClick={() => setFilter('pre-approved')} sx={getBoxStyle('pre-approved')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <AppWidgetSummary title="Refinance Accepted Leads" total={totalRefiAcceptedLeads} color="secondary" icon={'ic:baseline-monetization-on'} onClick={() => setFilter('refi-accepted')} sx={getBoxStyle('refi-accepted')} />
        </Grid>
      </Grid>

      {/* Leads Overview */}
      <Card sx={{ mb: 5 }}>
        <Typography variant="h6" sx={{ mb: 2, p: 2 }}>Leads Overview</Typography>
        <Box sx={{ height: 500 }}>
          <DataGrid
            rows={leadData}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            checkboxSelection
            disableSelectionOnClick
            components={{ Toolbar: GridToolbar }}
            getRowId={(row) => row._id}
          />
        </Box>
      </Card>

      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Confirm Change</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the assigned agent for this lead?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmChange} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {loading && (
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          zIndex: 1,
        }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>Loading Leads...</Typography>
        </Box>
      )}
    </Container>
  );
}
